/*!
 * SAPUI5
 * Copyright (c) 2025 SAP SE or an SAP affiliate company. All rights reserved.
 */
import CustomTreeItem, { $CustomTreeItemSettings } from "sap/m/CustomTreeItem";
import CustomData from "sap/ui/core/CustomData";

interface AccessibilityInfo {
    description?: string;
    [key: string]: unknown;
}
/**
 * @namespace sap.esh.search.ui.tree
 */
export default class TreeViewItem extends CustomTreeItem {
    constructor(sId?: string, options?: Partial<$CustomTreeItemSettings>) {
        super(sId, options);
        this.addCustomData(
            new CustomData({
                key: "esh-tree-node-id",
                value: {
                    parts: [{ path: "id" }],
                    formatter: (id) => {
                        if (typeof id !== "undefined") {
                            return id.toString();
                        } else {
                            return "";
                            // returning current value of 'id' (undefined), causes console error '[FUTURE FATAL] CustomData ... but the value is not a string'
                        }
                    },
                },
                writeToDom: true,
            })
        );
    }
    public getAccessibilityInfo(
        ...args: Parameters<CustomTreeItem["getAccessibilityInfo"]>
    ): AccessibilityInfo {
        const accInfo: AccessibilityInfo = super.getAccessibilityInfo(...args) ?? {};
        accInfo.description = "";
        return accInfo;
    }

    static renderer = {
        apiVersion: 2,
    };
}
